<template>
    <div>
        <projetos 
            :projetos="projetos" 
            :pnlVencimentos="pnlVencimentos"
            :servicos="obterServicos()"
            v-show="mostrarProjetos"
            @atualizarFiltro="atualizarFiltro($event)"
            @filtrarPorPeriodo="filtrarPorPeriodo($event)"
        >
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('SGTEC-GEST-PRJ-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharProjeto(data.projetoId)"
                    ></i>
                </span>
            </template>
        </projetos>
        <router-view></router-view>
    </div>
</template>

<script>
import ProjetosServicos from './ProjetosServicos'
import Projetos from '@/app/sgtec/componentes/projetos/Projetos'

export default {
    data() {
        return {
            projetos: [],
            filtro: {
                dataInicial: this.$moment(new Date())
                .startOf('year')
                .format('DD/MM/YYYY'),
                dataFinal: this.$moment(new Date())
                    .endOf('year')
                    .format('DD/MM/YYYY'),
                tipoContratacao: 'TODAS',
                natureza: 'TODAS',
                modulo: "TODOS",
                codSolucao: 0,
            },
            pnlVencimentos: {
                periodo1: 0,
                periodo2: 0,
                periodo3: 0,
                periodo4: 0
            }
        }
    },
    methods: {
        obterServicos() {
            return ProjetosServicos
        },

        filtrarPorPeriodo(periodoSelecionado){
            this.filtro.periodo = periodoSelecionado
            this.obterProjetos()
        },

        atualizarFiltro(filtro) {
            this.filtro = filtro
            this.obterProjetos()
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            ProjetosServicos.obterTodos(this.filtro).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data.projetos
                        this.pnlVencimentos = response.data.pnlVencimentos
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharProjeto(projetoId) {
            this.$router.push({
                name: 'Sgtec_Gestores_Projetos_Detalhar',
                params: {
                    projetoId: projetoId
                }
            })
        }
    },

    created() {
    },

    computed: {
        mostrarProjetos() {
            return this.$route.name === 'Sgtec_Gestores_Projetos'
        }
    },

    components: {
        Projetos: Projetos
    },

    watch: {
        $route(to) {
            if (to.name === 'Sgtec_Gestores_Projetos') {
                if (this.$store.getters.recarregar) {
                    this.obterProjetos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
